import { render } from "./FullCalendar.vue?vue&type=template&id=200ebd3a"
import script from "./FullCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./FullCalendar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Calendar/FullCalendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "200ebd3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('200ebd3a', __exports__)) {
    api.reload('200ebd3a', __exports__)
  }
  
  module.hot.accept("./FullCalendar.vue?vue&type=template&id=200ebd3a", () => {
    api.rerender('200ebd3a', render)
  })

}


export default __exports__